import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import * as Constants from "../../consts/Constants.js";
import redMarker from "../../assets/images/markers/redMarker.png";
import L from "leaflet";
import StayExpanded from "./StayExpanded";

export default function MapVisitUser(props) {
  const [center, setCenter] = React.useState({
    lat: Constants.LATITUD_AYACUCHO,
    lng: Constants.LONGITUD_AYACUCHO,
  });

  const [map, setMap] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [staySelected, setStaySelected] = React.useState(null);

  const getMarkers = (data) => {
    return data.map((stay, index) =>
      stay.center !== undefined ? (
        <Marker
          key={index}
          position={[stay.center.latitude, stay.center.longitude]}
          icon={
            new L.Icon({
              iconUrl: redMarker,
              iconSize: [32, 45],
              iconAnchor: new L.Point(32, 45),
            })
          }
          eventHandlers={{
            click: (e) => {
              setOpen(true);
              setStaySelected(stay);
            },
          }}
        />
      ) : null
    );
  };

  return (
    <div>
      <MapContainer
        style={{
          height: "550px",
          width: "100%",
          zIndex: 399,
        }}
        center={center}
        zoom={15}
        scrollWheelZoom={true}
        whenCreated={setMap}
      >
        {props ? getMarkers(props.data) : null}
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
      <StayExpanded open={open} setOpen={setOpen} staySelected={staySelected} />
    </div>
  );
}
